<template>
  <div class="data-table">
    <!-- LOOP :: HEADERS & CONTENTS :: DESKTOP -->
    <div class="data-container   ">
      <div
        v-for="(header, i) in headers"
        :key="i"
        :style="{ width: header.width }"
        class="hidden md:block"
      >
        <div class="header-container">
          <div class="header capitalize">{{ header.key }}</div>

          <!-- SORT -->
          <div
            class="sort-buttons invisible md:visible"
            :style="{
              visibility:
                header.sortable && $data.$screenSize.width > 768
                  ? 'visible'
                  : 'hidden',
            }"
          >
            <i
              @click="
                sortByKey = header.key;
                order = 'ASC';
                dataType = header.dataType ? header.dataType : 'string';
              "
              :class="
                header.key === sortByKey && order === 'ASC'
                  ? `selected-sort`
                  : `unselected-sort`
              "
              class="fas fa-arrow-up py-1 px-1"
            ></i>
            <i
              @click="
                sortByKey = header.key;
                order = 'DESC';
                dataType = header.dataType ? header.dataType : 'string';
              "
              :class="
                header.key === sortByKey && order === 'DESC'
                  ? `selected-sort`
                  : `unselected-sort`
              "
              class="fas fa-arrow-down px-1"
            ></i>
          </div>
          <!-- /SORT -->
        </div>

        <!-- LOOP :: ITEMS -->
        <div class="content-container">
          <div
            class="content-row"
            v-for="(item, j) in filteredItems"
            :key="j"
            :style="{ background: j % 2 === 0 ? '#fafafa' : '#ffffff' }"
          >
            <!-- Big Content -->
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{
                    item[header.key] | shorten(header.restrictToLen)
                  }}</span>
                </template>
                <span class="capitalize">{{ item[header.key] }}</span>
              </v-tooltip>
            </div>
            <!-- /Big Content -->

            <!-- ACTIONS -->
            <div
              v-if="header.type === 'actions'"
              class="actions hidden-xs-only"
            >
              <div class="loop">
                <lms-button class="block mb-2" @click="navigate(item.id)"
                  >View</lms-button
                >
              </div>
            </div>
            <!-- /ACTIONS -->
          </div>
        </div>
        <!-- /LOOP :: ITEMS -->
      </div>
    </div>
    <!-- /LOOP :: HEADERS & CONTENTS :: DESKTOP -->

    <!-- LOOP :: HEADERS & CONTENTS :: MOBILE -->
    <div class="mobile-content md:hidden">
      <div v-for="(items, i) in filteredItems" class="items-row" :key="i">
        <div
          v-for="(header, j) in headers"
          class="header-row"
          :key="`header-${j}`"
        >
          <div v-if="header.type !== 'actions'" class="key-content">
            <div class="key capitalize">
              {{ header.key }}
            </div>
            <div class="content capitalize">{{ items[header.key] }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- /LOOP :: HEADERS & CONTENTS :: MOBILE -->
  </div>
</template>

<script>
import { INTERSECTION, SORT_ARR_OF_OBJ } from "@/utils/array";
import shortenText from "@/utils/shorten-text";
export default {
  components: {
    LmsButton: () => import("@/components/general/button"),
  },
  mixins: [shortenText],
  props: ["headers", "items", "filters", "search", "actions"],
  data() {
    return {
      // EDIT
      editRow: 0,
      editDialog: false,
      // /EDIT
      // SEARCH
      q: "",
      // /SEARCH
      // SORT
      sortByKey: "",
      order: "",
      dataType: "",
      // /SORT
      // MOBILE FILTER DIALOG
      mobileFilterDialog: false,
      // /MOBILE FILTER DIALOG
    };
  },
  computed: {
    filteredItems() {
      return this.filter();
    },
    isAnyFilterSelected() {
      return this.isFilterSelected();
    },
  },
  watch: {
    editDialog: {
      handler() {
        if (this.editDialog) {
          setTimeout(() => this.$refs.edit[0].focus(), 10);
        }
      },
    },
  },
  methods: {
    navigate(id) {
      this.$router.push({
        name: "learner-single-submission",
        params: { id },
      });
    },
    filter() {
      //////console.log({ filter: this.filters })
      let arrOfItems = [];
      // LOOP :: FILTERS
      for (let i in this.filters) {
        let filter = this.filters[i];
        if (filter.modal) {
          //////console.log({ filter, i })
          arrOfItems.push([]);
          let itemsIndex = arrOfItems.length - 1;
          // LOOP :: ITEMS
          for (let j in this.items) {
            let item = this.items[j];
            //////console.log({ item, j, value: item[filter.key] })
            // FILTER :: TYPES
            // 1
            if (filter.type === "input-date") {
              if (item[filter.key].includes(filter.modal)) {
                arrOfItems[itemsIndex].push(JSON.stringify(item)); // 1
              }
            }
            // 2
            if (filter.type === "select-range") {
              if (
                parseFloat(filter.modal.min) <= parseFloat(item[filter.key]) &&
                parseFloat(filter.modal.max) >= parseFloat(item[filter.key])
              ) {
                arrOfItems[itemsIndex].push(JSON.stringify(item)); // 2
              }
            }
            // /FILTER :: TYPES
          }
          // LOOP :: ITEMS
        }
      }
      // /LOOP :: FILTERS
      //////console.log({ arrOfItems })
      // FINAL
      let filteredItems = [];
      // CHECK IF NO FILTER SELECTED
      if (arrOfItems.length === 0) {
        ////console.log('NO FILTER SELECTED')
        filteredItems = this.items;
      }
      // /CHECK IF NO FILTER SELECTED
      else {
        ////console.log('FILTER SELECTED')
        // CHECK IF ANYONE ITEMS ARR EMPTY, THIS MEANS NO COMMON
        let isAnyOneItemsArrEmpty = false;
        for (let i in arrOfItems) {
          let items = arrOfItems[i];
          if (items.length === 0) {
            isAnyOneItemsArrEmpty = true;
          }
        }
        if (isAnyOneItemsArrEmpty) {
          ////console.log('ANYONE ARRAY IS EMPTY, NO COMMON')
          filteredItems = [];
        } else {
          ////console.log('COMMON')
          // CHECK IF ONLY ONE FILTER SELECTED, NOTING TO FIND COMMON
          if (arrOfItems.length === 1) {
            ////console.log('ONLY ONE ARRAY, NO NEED TO FIND INTERSECTION')
            filteredItems = arrOfItems[0];
          } else {
            ////console.log('INTERSECTION')
            // INTERSECTION
            filteredItems = INTERSECTION({ arrOfArr: arrOfItems });
            ////console.log({ intersection: filteredItems })
            // /INTERSECTION
          }
          // /CHECK IF ONLY ONE FILTER SELECTED, NOTING TO FIND COMMON
        }
        // /CHECK IF ANYONE ITEMS ARR EMPTY, THIS MEANS NO COMMON
      }
      ////console.log({ filteredItems })
      // /FINAL
      // PARSE
      let parsedItems = [];
      for (let i in filteredItems) {
        let item = filteredItems[i];
        if (typeof item === "string") {
          item = JSON.parse(item);
        }
        parsedItems.push(item);
      }
      ////console.log({ parsedItems })
      // /PARSE
      // SEARCH
      let searchedItems = [];
      if (this.search && this.q.length > 0) {
        for (let i in parsedItems) {
          let item = parsedItems[i];
          ////console.log({ item })
          let isMatch = false;
          for (let key in item) {
            let val = JSON.stringify(item[key]);
            ////console.log({ val })
            if (val.toLowerCase().includes(this.q.toLowerCase())) {
              isMatch = true;
            }
          }
          ////console.log({ isMatch })
          if (isMatch) {
            searchedItems.push(item);
          }
        }
      } else {
        searchedItems = parsedItems;
      }
      ////console.log({ searchedItems })
      // SEARCH
      // SORT
      let sortedArr;
      if (this.sortByKey.length > 0) {
        sortedArr = SORT_ARR_OF_OBJ({
          arr: searchedItems,
          key: this.sortByKey,
          order: this.order,
          dataType: this.dataType,
        });
      } else {
        // NO DEFAULT SORTING
        sortedArr = searchedItems;
      }
      ////console.log({ sortedArr })
      return sortedArr;
      // /SORT
    },
    intiDefaultSort() {
      // FIND DEFAULT KEY, ORDER TO SORT
      for (let i in this.headers) {
        let header = this.headers[i];
        ////console.log({ header })
        if (header.defaultSortBy) {
          this.sortByKey = header.key;
          this.order = header.defaultOrder;
        }
      }
      ////console.log({ sortByKey: this.sortByKey, order: this.order })
      // /FIND DEFAULT KEY, ORDER TO SORT
    },
    // ACTION :: EDIT
    editAction({ row, func }) {
      ////console.log({ editAction: { row } })
      func({ row, index: row.dbIndex, vm: this });
    },
    // ACTION :: EDIT
    isFilterAvailable() {
      if (this.filters) {
        if (this.filters.length === 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    isFilterSelected() {
      if (this.filters) {
        for (let i in this.filters) {
          let filter = this.filters[i];
          ////console.log({ filter })
          if (filter.modal) {
            if (JSON.stringify(filter.modal).length > 0) {
              ////console.log('TRUE')
              return true;
            }
          }
        }
      }
      ////console.log('FALSE')
      return false;
    },
    clearAllFilters() {
      for (let i in this.filters) {
        this.filters[i]["modal"] = "";
        delete this.filters[i]["modal"];
      }
    },
  },
  created() {
    this.intiDefaultSort();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/data-table";
</style>
